import platformBackendClient from '@backend-clients/platform-backend';

export default {
  getScans: () => platformBackendClient.get('/api/skydio/scans'),
  getFlights: () => platformBackendClient.get('/api/skydio/flights'),
  import: (body, query) => platformBackendClient.post('/api/skydio/import', body, { params: query }),
};
